import React from 'react'

import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useEmployeePendingApprovalFlows } from 'modules/approvals/hooks/useEmployeePendingApprovalFlows'

const RESOLVE_LATER = 'resolve_pending_approvals_later'
const DISCARD = 'discard_pending_approvals'

interface Props {
  form: Form
  accessId: number
  companyId: number
}

const PendingApprovals = ({ form, accessId, companyId }: Props) => {
  const [checked, setChecked] = React.useState<boolean>(false)
  const data = useEmployeePendingApprovalFlows(accessId, companyId)

  const onSelect = (value: boolean) => {
    form.setValues({ stop_pending_approvals: value })
    setChecked(value)
  }

  const totalPendingApprovals = data.reduce((acc, { totalPending }) => acc + totalPending, 0) || 0

  if (totalPendingApprovals === 0) return null

  return (
    <Box gap="s16">
      <Text.Normal>
        {i18n.t('employee_form.pending_approvals_stats', { count: totalPendingApprovals })}
      </Text.Normal>
      <Box gap="s8">
        <RadioButton
          name="pending_approvals"
          onChange={() => onSelect(false)}
          checked={!checked}
          value={RESOLVE_LATER}
          label={i18n.t('employee_form.resolve_pending_approvals_later')}
        />
        <RadioButton
          name="pending_approvals"
          onChange={() => onSelect(true)}
          checked={checked}
          value={DISCARD}
          label={i18n.t('employee_form.discard_pending_approvals')}
        />
      </Box>
    </Box>
  )
}

export default observer(PendingApprovals)
